import * as React from 'react';
import * as _ from 'lodash';
import FormInput from '../FormInput';
import {ExtendedWrappedFieldProps} from '../FormFields';
import FormHelperText from '@material-ui/core/FormHelperText';
import {WithStyles} from '@material-ui/core/styles/withStyles';
import {withStyles} from '@material-ui/core/styles';
import {ExtendedInputProps} from '@material-ui/core/Input';
import FormSelect, {FormSelectProps} from '../FormSelect';
import {FormSelectOptions} from '../utils/orderByUtils';

type DeprecatedFieldType = 'text' | 'keyword' | 'long' | 'number' | 'images' | 'date' | 'html';
export type FieldType = 'select' | 'shortString' | 'integer' | 'float' | DeprecatedFieldType;

export interface TypedFieldInfo extends Pick<FormSelectProps, 'createOnBlur' | 'hideCreatedOption' | 'creatable'> {
  maxLength?: number;
  minLength?: number;
  valueFormatter?: string;
  formatErrorMessage?: string;
  maxValue?: number;
  minValue?: number;
  decimalScale?: number;
  creatable?: boolean;
  options?: FormSelectOptions;
}

const styles = {
  charCounter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

export interface TypedFormFieldProps
  extends ExtendedWrappedFieldProps,
    TypedFieldInfo,
    Pick<ExtendedInputProps, 'autoSelect'> {
  type: FieldType;
}

const TypedFormField: React.FunctionComponent<TypedFormFieldProps & WithStyles<typeof styles>> = ({
  type,
  maxLength,
  minLength,
  maxValue,
  minValue,
  decimalScale,
  valueFormatter,
  createOnBlur,
  hideCreatedOption,
  formatErrorMessage,
  classes: {charCounter},
  options,
  ...props
}) => {
  switch (type) {
    case 'shortString':
      return (
        <FormInput
          autoSelect
          formHelperText={
            maxLength ? (
              <FormHelperText className={charCounter}>{`${_.size(props.input.value)}/${maxLength}`}</FormHelperText>
            ) : (
              undefined
            )
          }
          {...props}
        />
      );
    case 'integer':
      return <FormInput numberFormatProps={{decimalScale: 0}} {...props} />;
    case 'float':
      return <FormInput numberFormatProps={{decimalScale}} {...props} />;
    case 'select':
      return (
        <FormSelect
          hideCreatedOption={hideCreatedOption}
          createOnBlur={createOnBlur}
          clearable
          options={options}
          {...props}
        />
      );
    default:
      return <FormInput autoSelect {...props} />;
  }
};

TypedFormField.defaultProps = {
  decimalScale: 2,
  autoSelect: true,
  type: 'shortString',
};

export default withStyles(styles)(TypedFormField);
